'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

var _campaigns = require('../../../api/campaigns');

var _client = require('../../../utils/client');

var _loading = require('constructicon/loading');

var _loading2 = _interopRequireDefault(_loading);

var _metric = require('constructicon/metric');

var _metric2 = _interopRequireDefault(_metric);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withGroups = function withGroups(ComponentToWrap) {
  return function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.fetchGroups = _this.fetchGroups.bind(_this);

      _this.state = {
        error: null,
        fields: null,
        isFetched: (0, _client.isJustGiving)()
      };
      return _this;
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!(0, _client.isJustGiving)()) this.fetchGroups();
      }
    }, {
      key: 'fetchGroups',
      value: function fetchGroups() {
        var _this2 = this;

        var campaignId = this.props.campaignId;


        (0, _campaigns.fetchCampaignGroups)(campaignId).then(function (groups) {
          var fields = {};

          if (groups.length) {
            groups.forEach(function (_ref) {
              var key = _ref.key,
                  label = _ref.label,
                  values = _ref.values;

              var options = [{
                label: 'Please select',
                value: '',
                disabled: true
              }].concat(_toConsumableArray(values.map(function (value) {
                return {
                  label: value,
                  value: value
                };
              })));

              fields['group_values_' + key] = {
                label: label,
                options: options,
                type: 'select',
                required: true,
                validators: [validators.required('Please select an option')]
              };
            });
          }

          return _this2.setState({
            fields: fields,
            isFetched: true
          });
        }).catch(function (error) {
          return _this2.setState({ error: (0, _get2.default)(error, 'data.error.message') });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            error = _state.error,
            isFetched = _state.isFetched;


        return error ? _react2.default.createElement(_metric2.default, { icon: 'warning', label: error }) : isFetched ? _react2.default.createElement(ComponentToWrap, _extends({}, this.props, {
          fields: (0, _merge2.default)(this.props.fields, this.state.fields)
        })) : _react2.default.createElement(_loading2.default, null);
      }
    }]);

    return _class;
  }(_react.Component);
};

exports.default = withGroups;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/create-page-form/with-groups/index.js
// module id = 1432
// module chunks = 0